import { render } from "./Jumbotron.vue?vue&type=template&id=bc72b6bc"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"

import "./Jumbotron.vue?vue&type=style&index=0&id=bc72b6bc&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__